import React from 'react'
import { components } from 'react-select'

const MultiValueContainer = (props) => <components.MultiValueContainer {...props} />

export { MultiValueContainer }
